module.exports = "../../static/img/logo.062f25d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = 611
// module chunks = 1